<template>
  <el-dialog
    class="rc-dialog"
    :title="detailTitle"
    :visible.sync="showBatchUpdate.flag"
    :close-on-click-modal="false"
    @close="close"
    destroy-on-close
    width="50%"
  >
    <el-form
      :model="ruleForm"
      ref="rForm"
      label-width="125px"
      class="ruleForm"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="审核结果："
            prop="auditSchedule"
            :rules="[{ required: true, message: '请选择审核意见' }]"
          >
            <el-radio-group
              v-model="ruleForm.auditSchedule"
              @change="auditScheduleChange"
            >
              <el-radio
                v-for="(item, i) in auditScheduleAttr.slice(1, 3)"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item
            label="退回原因："
            prop="auditContent"
            v-if="ruleForm.auditSchedule == 1"
            ref="refuse"
            :rules="[{ required: true, message: '请输入退回原因' }]"
          >
            <el-input
              type="textarea"
              placeholder="请输入退回原因"
              :row="3"
              v-model="ruleForm.auditContent"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item
            label="短信通知："
            prop="isNotice"
            :rules="[{ required: true, message: '请选择短信通知' }]"
          >
            <el-radio-group
              v-model="ruleForm.isNotice"
            >
              <el-radio
                v-for="(item, i) in isNoticeAttr"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="ruleForm.isNotice">
        <el-row>
          <el-col>
            <el-form-item label="消息内容：" prop="sendMessage">
              <el-input
                v-model="ruleForm.sendMessage"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="发送对象：" prop="operatorName" ref="send">
              <span>{{ ruleForm.operatorName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="close" title="取消"></butn>
      <butn
        btntype="primary"
        @click="updateForm"
        title="确定"
        v-permission="'user:audit:update'"
      ></butn>
    </div>
  </el-dialog>
</template>
<script>
import { auditHistoryUpdate } from "@/api/moveAudit";
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import { getEnums } from "@/utils/common.js";

export default {
  components: { butn },
  props: {
    showBatchUpdate: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    selectAudits: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ruleForm: {
        auditSchedule: "2",
        auditContent: "",
        sendMessage: "",
        isNotice: true,
        // sendPerson: [],
        sendPersonMap: {},
        auditApplyIds: [],
        operatorName: "",
      },
      detailTitle: "批量调动审核",
      auditScheduleAttr: [],
      isNoticeAttr: [
        { paramValue: "否", paramKey: false },
        { paramValue: "是", paramKey: true },
      ],
      agreeText: "您好，您提交的{调动记录数}条调动申请已审核通过。",
      disagreeText: "您好，您提交的{调动记录数}条调动申请未审核通过，退回原因：{退回原因}",
    };
  },
  methods: {
    dealSelectAudits() {
      if (this.selectAudits && this.selectAudits.length > 0) {
        let selectList = [...this.selectAudits];
        // 处理选中的数组，组装数据
        // 去重获取operatorName(selectList为根据，操作人电话去重数组)
        // 以操作人电话为key。操作人所对应调动条数为value
        const peon = {}
        selectList = selectList.reduce((acc, next) => {
          if (peon[next.operatorMobile]) {
            peon[next.operatorMobile] += 1
          } else {
            if (peon[next.operatorMobile] = 1) {
              acc.push(next);
            }
          }
          return acc
        }, [])
        // 审核ids
        this.ruleForm.auditApplyIds = this.selectAudits.map(o => o.uuid);
        // 操作人ids
        // this.ruleForm.sendPerson = selectList.map( o => o.operatorId);
        // 操作人电话所对应调用条数map
        this.ruleForm.sendPersonMap = peon;
        // 操作人names
        this.ruleForm.operatorName = selectList.map( o => o.operatorName).join('，');
        // 短信模板
        this.ruleForm.sendMessage = this.agreeText;
      }
    },
    auditScheduleChange(e) {
      if (e == 2) {
        this.ruleForm.sendMessage = this.agreeText;
      } else if ( e == 1) {
        this.ruleForm.sendMessage = this.disagreeText;
      }
    },
    // 关闭
    close() {
      this.$emit('close');
      this.$refs["rForm"].resetFields();
    },
    // 确定
    updateForm() {
      this.$refs["rForm"].validate((valid) => {
        if (valid) {
          let params = {...this.ruleForm};
          delete params['operatorName']
          if (!params.isNotice) {
            delete params['sendMessage']
            delete params['sendPersonMap']
          }
          auditHistoryUpdate(params).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              Bus.$emit("refreshTable");
            }
          });
          this.$emit('close');
        }
      });
    },
  },
  created() {
    getEnums(
      ["AUDIT_SCHEDULE"],
      this,
      ["auditScheduleAttr"],
      [false, false, false]
    );
    this.dealSelectAudits();
  },

};
</script>

<style lang="scss" scoped>
.el-dialog__body {
  padding: 20px;
  overflow-y: auto;
  max-height: 500px !important;
}
</style>

